import type { EduCoursePaymentsCollectionState } from './edu-course-payments.reducer';
import type { CollectionsState } from '../collections-feature.reducer';

import { createSelector } from '@ngrx/store';
import { EDU_COURSE_PAYMENTS_COLLECTION_FEATURE_KEY, eduCoursePaymentsAdapter } from './edu-course-payments.reducer';
import { collectionsState } from '../collections-state.selectors';

const { selectCollectionQuery, selectCollectionQueryStatuses } = eduCoursePaymentsAdapter.getSelectors();

export const selectEduCoursePaymentsState = createSelector(
    collectionsState,
    (state: CollectionsState): EduCoursePaymentsCollectionState => state[EDU_COURSE_PAYMENTS_COLLECTION_FEATURE_KEY]
);

export const selectEduCoursePayments = (courseId: string) =>
    createSelector(selectEduCoursePaymentsState, selectCollectionQuery(courseId));

export const selectEduCoursePaymentsStatuses = (courseId: string) =>
    createSelector(selectEduCoursePaymentsState, selectCollectionQueryStatuses(courseId));
